import React, { useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { css } from "styled-components/macro"; // eslint-disable-line
import illustration from "images/Sign up.svg";
import Light from "./headers/light";
import { ReactComponent as EyeIcon } from "feather-icons/dist/icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "feather-icons/dist/icons/eye-off.svg";
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';
import Footerr from "./footers/Footer";
import logo from "images/logo.png";

const Form = tw.form`mx-auto max-w-xs`;
const Container = tw(ContainerBase)`min-h-screen text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;

const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center`}
  ${({ disabled }) =>
    disabled
      ? tw`bg-[#707070] cursor-not-allowed`
      : tw`bg-[#000000] text-gray-100 hover:bg-[#000000] focus:bg-[#000000] active:bg-[#000000]`}
  &:disabled {
    background-color: #707070 !important;
    cursor: not-allowed !important;
  }
`;
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-[#000000] text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-sm bg-contain bg-center bg-no-repeat`}
`;

const Signup = ({
  logoLinkUrl = "#",
  illustrationImageSrc = illustration,
  // headingText = "Créer un compte",
  submitButtonText = "S'inscrire",
  signupUrl = "login",
}) => {
const { i18n, t } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [c_password, setC_password] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [role, setRole] = useState("supplier");
  const [isChecked, setIsChecked] = useState(false);

  const navigate = useNavigate();

  const errorTranslations = {
    "The email has already been taken.": "Cet email est utilisé.",
    "The email field is required.": "L'adresse email est obligatoire.",
    "The password field must be at least 8 characters.": "Le mot de passe doit comporter au moins 8 caractéres.",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors([]);

    if (password !== c_password) {
      setErrors(["Les mots de passe ne correspondent pas"]);
      setLoading(false);
      return;
    }

    if (!/^[0-9]+$/.test(phone)) {
      setErrors(["Le numéro de téléphone ne doit contenir que des chiffres."]);
      setLoading(false);
      return;
    }

const userData = { 
    name, 
    email, 
    phone: "+212" + phone,   // <-- always send full international number
    address, 
    password, 
    role 
};

    try {
      const response = await axios.post("  https://jolyaparis.cloud/api/register", userData);

      if (response.status === 201) {
        Swal.fire({
          title: t('Inscription_réussie'),
          text: t('creation_compte'),
          icon: "success",
          confirmButtonText: t('D_accord'),
        }).then(() => {
          navigate("/login");
        });
      } else {

        setErrors(["Vérifiez vos informations et réessayez"]);
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data.errors) {
        const backendErrors = error.response.data.errors;
        const allMessages = [];

        for (let field in backendErrors) {
          if (Array.isArray(backendErrors[field])) {
            backendErrors[field].forEach((msg) => {
              const translated = errorTranslations[msg] || msg;
              allMessages.push(translated);
            });
          }
        }
        setErrors(allMessages);
      } else if (error.request) {
        setErrors(["Vérifiez vos informations et réessayez"]);
      } else {
        setErrors(["Vérifiez vos informations et réessayez"]);
      }
    }

    setLoading(false);
  };

  return (
    <AnimationRevealPage>
      <Light />
      <br />
      <br />
      <Container>
        <Content>
          <MainContainer>
            <LogoLink href={logoLinkUrl}>
              <LogoImage src={logo} />
            </LogoLink>
            <MainContent>
              <Heading>{t('Créer_un_compte')}</Heading>
              <FormContainer>
                <Form onSubmit={handleSubmit}>
                  <Input type="text" value={name} onChange={e => setName(e.target.value)} placeholder={t('Nom_Complet')} required />
                  <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={t('Email')} required />
<Input
  type="tel"
  style={i18n.language === 'ar' ? { textAlign: 'end' } : {}}
  value={"+212 " + phone}
  onChange={(e) => {
    let val = e.target.value.replace("+212", "").trim();   // remove prefix
    val = val.replace(/\D/g, "");                         // digits only

    // REMOVE leading 0 if exists
    if (val.startsWith("0")) {
      val = val.substring(1);
    }

    setPhone(val);
  }}
  placeholder={t('Numéro_de_Téléphone')}
  required
/>


                  <Input type="text" value={address} onChange={e => setAddress(e.target.value)} placeholder={t('Adresse')} required />
<br />

                  {/* Role Select */}
                  <select
                    value={role}
                    onChange={e => setRole(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "16px",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                      background: "#f7fafc",
                      color: "#333",
                      fontSize: "15px",
                      marginTop: "10px"
                    }}
                    required
                  >
                    <option value="supplier">{t('Distributeur')}</option>
                    <option value="influenceur">{t('Influenceur')}</option>
                    <option value="client_fidele">{t('Client_fidele')}</option>
                  </select>
                  <br />

                  {/* Password */}
                  <div style={{ position: "relative" }}>
                    <Input type={showPassword ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} placeholder={t('Mot_de_passe')} required />
                    <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer" }}>
                      {showPassword ? <EyeOffIcon width={20} height={20} /> : <EyeIcon width={20} height={20} />}
                    </button>
                  </div>
<br/>

                  {/* Confirm Password */}
                  <div style={{ position: "relative" }}>
                    <Input type={showConfirmPassword ? "text" : "password"} value={c_password} onChange={e => setC_password(e.target.value)} placeholder={t('Confirmer_motdepass')} required />
                    <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer" }}>
                      {showConfirmPassword ? <EyeOffIcon width={20} height={20} /> : <EyeIcon width={20} height={20} />}
                    </button>
                  </div>

                  {/* Error Messages */}
                  {errors.length > 0 && (
                    <div tw="mt-4 text-red-600 text-sm">
                      <ul tw="list-disc list-inside">
                        {errors.map((msg, index) => <li key={index}>{msg}</li>)}
                      </ul>
                    </div>
                  )}

                  {/* Checkbox */}
                  <div className="flex items-center mt-4">
                    <input
                      type="checkbox"
                      id="terms"
                      required
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                      className="mr-2"
                    />
                    <label htmlFor="terms" tw="text-xs text-gray-600">{t('termes_conditions')}</label>
                  </div>

                  {/* Submit */}
                  <SubmitButton type="submit" disabled={!isChecked}>
<span>{loading ? t('Loading') :t('S_inscrire') }</span>
                  </SubmitButton>
                </Form>

                <p tw="mt-6 text-xs text-gray-600 text-center">
                  {t('Respectez')}
                </p>
                <p tw="mt-8 text-sm text-gray-600 text-center">
                  {t('Avez_vous_compte')}{" "}
                  <a href={signupUrl} tw="border-b border-gray-500 border-dotted">
{t('se_connecter')}                  </a>
                </p>
              </FormContainer>
            </MainContent>
          </MainContainer>

          <IllustrationContainer>
            <IllustrationImage imageSrc={illustrationImageSrc} />
          </IllustrationContainer>
        </Content>
      </Container>
      <br />
      <Footerr />
    </AnimationRevealPage>
  );
};

export default Signup;
